import { Immutable } from "immer";
import React from "react";

import type { StearnsFinanceOptionsBlock as Value } from "@reactivated";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

type Props = Immutable<{
    value: Value;
}>;

export const StearnsFinanceOptionsBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    // Faithful port of the legacy `finance_page.html` page-loop markup:
    //   <h3 class="finance-page__header">{{ block.value.title }}</h3>
    //   <div class="finance-table__table">{{ block.value.html }}</div>
    // `title` is a CharBlock (plain text); `html` is a RawHTMLBlock whose value
    // already arrives wrapped in <div class="raw-html-block"> from the server, so
    // we render it raw (do NOT strip the wrapper) to match the original output.
    return (
        <>
            <h3 className="finance-page__header">{v.title}</h3>
            <EditorContent>
                {(marker) => (
                    <div
                        className="finance-table__table"
                        dangerouslySetInnerHTML={{ __html: v.html ?? "" }}
                        {...marker}
                    />
                )}
            </EditorContent>
        </>
    );
};
